import init from '../../common/base/init';

init(() => {
  const form = document.querySelector('.seminars-suggest-modal form');
  if(!form) return;

  const message = form.querySelector('.-response');
  const modal = form.closest('.a11ydialog');

  form.addEventListener('ajax:success', (e) => {
    const response = e.detail[0];

    message.innerHTML = response.content;
    message.classList.add('-response--show');

    if(response.success) {
      form.reset();
    }
    else {
      // TODO: scroll to the `message` element
    }
  });

  modal.A11yDialogInstance.on('hide', () => {
    message.classList.remove('-response--show');
  });
});
